import { NgModule } from '@angular/core'
import { WebsocketService } from './websocket.service'
import { WebsocketAuthCommand } from './websocket-auth.command'
import { WebsocketCommandsService } from './websocketCommands.service'
import { WebsocketMapperService } from './websocket-mapper.service'

export { WebsocketService } from './websocket.service'
export { type IWsMessage, type WsMessageEventTypes } from './websocket.interface'

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [WebsocketService, WebsocketAuthCommand, WebsocketCommandsService, WebsocketMapperService],
})
export class WebsocketModule {}
